import { render, staticRenderFns } from "./block-title.vue?vue&type=template&id=559c280a&scoped=true"
import script from "./block-title.vue?vue&type=script&lang=js"
export * from "./block-title.vue?vue&type=script&lang=js"
import style0 from "./block-title.vue?vue&type=style&index=0&id=559c280a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559c280a",
  null
  
)

export default component.exports